export const SITE_ORIGIN = 'https://baristabot.app';

export const SCHEMA_IDS = {
  organization: `${SITE_ORIGIN}/#organization`,
  app: `${SITE_ORIGIN}/#app`,
  website: `${SITE_ORIGIN}/#website`,
  founder: `${SITE_ORIGIN}/#founder`,
  faqPage: `${SITE_ORIGIN}/faq#faq`,
  faqWebPage: `${SITE_ORIGIN}/faq#webpage`,
};

/** Holding-company hub — this brand’s page (not the E+M homepage). */
export const LINKS = {
  espressoPlusMilk: 'https://espressoplusmilk.com/brands/barista-bot',
  espressoPrivacy: 'https://espressoplusmilk.com/privacy',
  espressoTerms: 'https://espressoplusmilk.com/terms',
  brandBaristaBot: 'https://espressoplusmilk.com/brands/barista-bot',
  brandMenuOps: 'https://espressoplusmilk.com/brands/menu-ops',
  brandAllCaps: 'https://espressoplusmilk.com/brands/all-caps',
  /** Product domains — only when leaving to use the product. */
  menuOps: 'https://menu-ops.com',
  allCaps: 'https://allcaps.coffee',
  account: 'https://account.baristabot.app',
  brandLogin: 'https://my.baristabot.app',
};

export const ADDRESS = {
  street: '219 NW 12th St',
  suite: 'Suite 23',
  city: 'Oklahoma City, OK 73103',
  query: '219+NW+12th+St+Suite+23+Oklahoma+City+OK+73103',
};

export function getMapsLink() {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  if (isIOS) {
    return `https://maps.apple.com/?q=${ADDRESS.query}`;
  }
  return `https://www.google.com/maps/search/?api=1&query=${ADDRESS.query}`;
}
